import {FC} from 'react'

type Props = {
  tracking: any
  url: string
  companyName: string
}

const Tracking: FC<Props> = ({url, companyName, tracking}) => {
  if (url) {
    return (
      <div>
        <span className='text-muted fw-bold text-muted d-block fs-7'>{companyName}</span>
        <a href={url} target='_blank' rel='noreferrer' className='text-hover-primary'>
          {tracking.trackingNumber} <i className='text-primary bi bi-box-arrow-up-right' />
        </a>
      </div>
    )
  }
  if (tracking && (tracking.trackingNumber || tracking.companyName)) {
    return (
      <div>
        {tracking.companyName && (
          <span className='text-muted fw-bold text-muted d-block fs-7'>{tracking.companyName}</span>
        )}
        {tracking.trackingNumber && (
          <span className='text-hover-primary'>{tracking.trackingNumber}</span>
        )}
      </div>
    )
  }

  return null
}

export default Tracking
